export const rudderTrack = async (title: string, object: any) => {
  const rudderanalytics = await import('rudder-sdk-js');
  return rudderanalytics.track(title, object);
};
